import type { ProductColour } from './productColour';
import { PRODUCT_COLOURS } from './productColours';

/**
 * Configurable surfaces that resolve colour from the shared finish library.
 * Availability is per-component; HEX/RAL records stay shared.
 */
export type DoorColourComponent = 'frame' | 'slab' | 'cill' | 'threshold';

/**
 * Optional deny/allow rule for a finish on one component.
 * An empty list means every library finish is available on every component.
 */
export interface FinishCompatibilityRule {
  colourId: string;
  component: DoorColourComponent;
  allowed: boolean;
  reason?: string;
}

/**
 * Product-rule compatibility matrix. Intentionally empty until restrictions
 * are authored. Do not infer limits from HEX, RAL, or supplier names here.
 */
export const FINISH_COMPATIBILITY_RULES: FinishCompatibilityRule[] = [];

export function isFinishAllowedForComponent(
  colourId: string,
  component: DoorColourComponent
): boolean {
  const rule = FINISH_COMPATIBILITY_RULES.find(
    (candidate) => candidate.colourId === colourId && candidate.component === component
  );
  return rule?.allowed ?? true;
}

export function listFinishesForComponent(component: DoorColourComponent): ProductColour[] {
  return PRODUCT_COLOURS.filter((colour) =>
    isFinishAllowedForComponent(colour.id, component)
  );
}
